import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';

import { inject, observer } from 'mobx-react';
import { Icon, Spin, Button } from 'antd';
import AirTable from 'air-ptable';

import './SMTable.css';

@withRouter
@inject('translationsStore')
@observer
export default class SMTable extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  assetsBind = serviceManagerId => {
    this.props.assetBinding(serviceManagerId);
  };

  editServiceManager = serviceManagerId => {
    this.props.onEdit(serviceManagerId);
  };

  render() {
    const { translationsStore } = this.props;

    const columns = [
      {
        dataIndex: 'uin',
        title: translationsStore.translate('serviceManagers.table.column.uin')
      },
      {
        dataIndex: 'commonName',
        title: translationsStore.translate('serviceManagers.table.column.commonName'),
        render: (text, record) => `${record.name || ''} ${record.surname || ''}`
      },
      {
        dataIndex: 'companyName',
        title: translationsStore.translate('serviceManagers.table.column.companyName')
      },
      {
        dataIndex: 'email',
        title: translationsStore.translate('serviceManagers.table.column.email')
      },
      {
        dataIndex: 'mobile',
        title: translationsStore.translate('serviceManagers.table.column.mobile')
      },
      {
        dataIndex: 'phone',
        title: translationsStore.translate('serviceManagers.table.column.phone')
      },
      {
        dataIndex: '',
        title: '',
        render: (text, record) => (
          <Fragment>
            <Button type="primary" onClick={() => this.editServiceManager(record.id)} style={{ marginRight: 20 }}>
              <Icon type="user" style={{ fontSize: 20 }} />
            </Button>
            <Button type="primary" onClick={() => this.assetsBind(record.id)}>
              <Icon type="reconciliation" style={{ fontSize: 20 }} />
            </Button>
          </Fragment>
        )
      }
    ];

    return (
      <div className="SMTable">
        <Spin spinning={!!this.props.loading}>
          <AirTable rowKey="uin" rowSelection={false} columns={columns} dataSource={this.props.dataSource || []} pagination={{ pageSize: 10, position: 'both' }} />
        </Spin>
      </div>
    );
  }
}
